import * as angular from 'angular';

import { TransitionService } from '@uirouter/angularjs';

import { ScriptTestMode, ComponentDefinition } from '../../models';
import { ISessionStorageService } from '../../services';
import { groupScriptModeChanged } from '../../common';

class ScriptTestModeController {
    static $inject = ['$scope', '$rootScope', '$transitions', 'sessionStorageService'];
    static properties = 'group-script-mode';

    selectedScriptTestMode: ScriptTestMode;
    scriptTestModes = ScriptTestMode;
    disabledModes: ScriptTestMode[];

    constructor(
        private _$scope: angular.IScope,
        private _$rootScope: angular.IRootScopeService,
        private _$transitions: TransitionService,
        private _sessionStorageService: ISessionStorageService) {
    }

    $onInit() {

        this._$scope.$watch(() => this.selectedScriptTestMode,
            (newValue) => {
                this._sessionStorageService.setTo(ScriptTestModeController.properties, newValue);
                this._$rootScope.$broadcast(groupScriptModeChanged, newValue);
            });

        this._$transitions.onSuccess({}, () => {
            this._$rootScope.$broadcast(groupScriptModeChanged, this.selectedScriptTestMode);
        });

        const prop = this._sessionStorageService.getFrom(ScriptTestModeController.properties);
        if (prop) {
            this.selectedScriptTestMode = parseInt(prop);
        } else {
            this.selectedScriptTestMode = ScriptTestMode.BeginDateValue;
        }

        if (!this.disabledModes) {
            this.disabledModes = [];
        }
    }
}

export const wtScriptTestMode: ComponentDefinition = {
    componentId: 'wtScriptTestMode',
    template: require('./scriptTestMode.component.html'),
    controller: ScriptTestModeController,
    controllerAs: 'vm',
    bindings: {
        selectedScriptTestMode: '=',
        disabledModes: '<?'
    }
};